<template>
  <transition name="fade">
    <component
      :is="layout"
      v-if="fetched">
      <transition name="switch">
        <router-view :key="$route.fullPath" />
      </transition>
    </component>
  </transition>
</template>

<script>
import FormUtils from './utils/FormUtils.js';
import SanitizeUtils from './utils/SanitizeUtils.js';
import Vue from 'vue';

export default {
  data () {
    return {
      fetched: false,
      currentTheme: localStorage.getItem('wedliny-crm-theme') || 'light',
      themes: ['light', 'dark']
    };
  },
  computed: {
    layout () {
      if (!this.$route.meta) {
        return 'default-layout';
      }

      return `${this.$route.meta.layout || 'default'}-layout`;
    },
  },
  mounted () {
    this.fetched = true;
    window.crmApp = {};
    this.autoRefreshToken();

    this.applyStoredTheme();

    this.$bus.$on('app-toggle-theme', this.toggleTheme);
    document.addEventListener('wheel', this.preventNumberScroll, { passive: true });
  },
  methods: {
    refreshToken () {
      FormUtils.submitInBackground(this, {
        endpoint: '/auth/generate-token',
        errorTitle: 'An error occurred',
        errorText: 'An error occurred during refreshing API access. Please reload the page.',
        successAction: (data) => {
          window.localStorage.setItem('token', data.access_token);
          window.localStorage.setItem('last-token-refresh', +new Date());
          Vue.prototype.$http.defaults.headers.Authorization = 'Bearer ' + SanitizeUtils.getToken();
        }
      });
    },
    autoRefreshToken () {
      setTimeout(() => {
        if (window.localStorage.getItem('token')) {
          let lastRefresh = parseInt(window.localStorage.getItem('last-token-refresh'), 10);

          if (+new Date() - lastRefresh > 30 * 60 * 1000) {
            this.refreshToken();
          }
        }

        this.autoRefreshToken();
      }, 1 * 60 * 1000);
    },
    applyTheme (theme) {
      Vue.set(this, 'currentTheme', theme);
      localStorage.setItem('wedliny-crm-theme', theme);
      document.documentElement.classList.remove('light', 'dark');
      document.documentElement.classList.add(theme);
    },
    applyStoredTheme () {
      let storedValue = localStorage.getItem('wedliny-crm-theme');
      let newTheme = storedValue;
      if (!storedValue || !this.themes.includes(storedValue)) {
        newTheme = 'light';
      }

      this.applyTheme(newTheme);
    },
    toggleTheme () {
      let currentIndex = this.themes.indexOf(this.currentTheme);
      let newTheme = this.themes[(currentIndex + 1) % this.themes.length];

      this.applyTheme(newTheme);
    },
    preventNumberScroll (e) {
      const el = document.activeElement;
      if (el && el.tagName === 'INPUT' && el.type === 'number' && el === e.target) {
        el.blur();
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('app-toggle-theme', this.toggleTheme);
    document.removeEventListener('wheel', this.preventNumberScroll);
  },
};
</script>

<style lang="scss">
@import './assets/scss/custom-elements.scss';

.switch-enter-to,
.switch-leave-to {
  transition: opacity .25s ease-out;
}
.main-content-container {
  margin-top: 5rem;
}
.switch-enter,
.switch-leave-to {
  left: 0;
  opacity: 0;
  position: absolute;
  top: 0;
  transform: none;
  width: 100%;
}
  body {
    overflow-x: hidden;
  }
</style>
